export default Backbone.View.extend({
	el: '#app-wrapper',

	removeInvalidFeedback: function( evt )
	{
		var fg = $(evt.target).closest('.form-group, #form-theme');
		fg.find('.is-invalid').removeClass('is-invalid');
		fg.find('.btn-outline-danger').removeClass('btn-outline-danger').addClass('btn-outline-dark');
		fg.find('.invalid-feedback, .text-danger').remove();
	},

	scrollTo: function( pos )
	{
		if( pos instanceof jQuery && pos.length == 0 )
		{
			return;
		}

		if( isNaN( pos ) )
		{
			pos = $(pos).offset().top - $("#app-header").height();
		}

		$('html, body').animate({ scrollTop: pos }, 500);
	},

	scrollToEventTarget: function( evt )
	{
		evt.preventDefault();
		this.scrollTo( evt.currentTarget );
	},

	removeInvalidFeedback: function( evt )
	{
		var fg = $(evt.target).closest('.form-group, #form-theme');
		fg.find('.is-invalid').removeClass('is-invalid');
		fg.find('.btn-outline-danger').removeClass('btn-outline-danger').addClass('btn-outline-dark');
		fg.find('.invalid-feedback, .text-danger').remove();
	},

	scrollToInvalidFeedback: function()
	{
		this.scrollTo( this.$('.is-invalid, .invalid-feedback').first().closest('form-group').addBack() );
	},

	showHeader: function()
	{
		$("#app-header").stop().animate({ top: 0 }, 500); //removeClass('d-none');
		$("#app-toolbar").removeClass('d-none');
	},
	hideHeader: function()
	{
		$("#app-header").stop().animate({ top: -$("#app-header").height() -1 }, 500); //addClass('d-none');
		$("#app-toolbar").addClass('d-none');
	},

	doRender: function( attrs )
	{
		// On ferme les modales !
		$('.modal').modal('hide');

		// On charge la page avec le nouvel HTML
		this.$el.html( this.template( attrs ) );

		// Et on averti du rendu au niveau de l'élément et de la vue
		this.$el.trigger('render');
		this.trigger('render');
	},
	render: function()
	{
		this.doRender( this.template() );
	},

	doUnload: function()
	{
		this.trigger('unload');
		this.stopListening();
		this.undelegateEvents();
// 		this.remove();
	},
	unload: function()
	{
		this.doUnload();
	}
})
